/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetInitiativePhaseRequest
 */
export interface SetInitiativePhaseRequest {
    /**
     * 
     * @type {string}
     * @memberof SetInitiativePhaseRequest
     */
    lifecyclePhase: string;
    /**
     * 
     * @type {string}
     * @memberof SetInitiativePhaseRequest
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof SetInitiativePhaseRequest
     */
    effectTenantId?: string;
}

/**
 * Check if a given object implements the SetInitiativePhaseRequest interface.
 */
export function instanceOfSetInitiativePhaseRequest(value: object): value is SetInitiativePhaseRequest {
    if (!('lifecyclePhase' in value) || value['lifecyclePhase'] === undefined) return false;
    return true;
}

export function SetInitiativePhaseRequestFromJSON(json: any): SetInitiativePhaseRequest {
    return SetInitiativePhaseRequestFromJSONTyped(json, false);
}

export function SetInitiativePhaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetInitiativePhaseRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lifecyclePhase': json['lifecyclePhase'],
        'reason': json['reason'] == null ? undefined : json['reason'],
        'effectTenantId': json['effectTenantId'] == null ? undefined : json['effectTenantId'],
    };
}

export function SetInitiativePhaseRequestToJSON(json: any): SetInitiativePhaseRequest {
    return SetInitiativePhaseRequestToJSONTyped(json, false);
}

export function SetInitiativePhaseRequestToJSONTyped(value?: SetInitiativePhaseRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lifecyclePhase': value['lifecyclePhase'],
        'reason': value['reason'],
        'effectTenantId': value['effectTenantId'],
    };
}

